<script setup>
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head } from '@inertiajs/inertia-vue3';
import PageHeader from "@/Components/PageHeader.vue";
import Buttons from "@/Components/Buttons.vue";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

defineProps({
    collaborators: Array,
    columnas: Array,
    userParam: Object
});

const rutaPrefijo = ref('collaborator');
const modulo = ref('Colaborador');
const modulos = ref('Colaboradores');
</script>

<template>
    <Head title="Colaboradores" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Colaboradores">
                <template #actions>
                    <!-- Ahora sólo los Admins financieros pueden crear colaboradores -->
                    <Buttons v-if="$page.props.auth.user.id_rol <= 3" :href="route(rutaPrefijo + '-create')" color="blue" size="header" icon="mdi:plus-circle" label="Nuevo" :hideLabelOnMobile="true" />
                    <Buttons v-else color="info" size="header" icon="mdi:information-outline" label="Solo RRHH puede registrar" title="El administrador RRHH tiene permisos para registrar nuevos colaboradores" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template>

        <div class="py-12">
            <div class="mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                    <div class="lg:col-span-4 bg-white rounded-md shadow-lg border p-4">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                        <CardBox v-if="collaborators.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced :modulo="modulo" :modulos="modulos" :data="collaborators" :fields="columnas" :ruta="rutaPrefijo" updateable searchdefault="apellidos" searchfocus :userParam="userParam" /><!-- exporteable visualable -->
                            </div>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
